import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class SalaryService {
  constructor(private http: HttpClient) {}

  createSalary(payload: any) {
    return this.http.post(`${environment.apiUrl}/salary/create`, payload);
  }

  getSalaryByMonth(month: number, year: number) {
    return this.http.get(`${environment.apiUrl}/salary/month/${month}/${year}`);
  }

  updateSalaryByNurseId(nurseId: string, payload: any) {
    return this.http.put(
      `${environment.apiUrl}/salary/update/${nurseId}`,
      payload
    );
  }

  updateSalaryByNurseIdAndMonth(
    nurseId: string,
    month: number,
    year: number,
    payload: any
  ) {
    return this.http.put(
      `${environment.apiUrl}/salary/update/${nurseId}/${month}/${year}`,
      payload
    );
  }

  getPagedSalary(payload: {
    pageIndex: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: number;
    nurseID: string;
  }) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/salary/get-paged`,
      requestPayload
    );
  }
}
